/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiScreeningDirection {
    REGULAR = 'REGULAR',
    INVERSE = 'INVERSE'
}


export function instanceOfApiScreeningDirection(value: any): boolean {
    for (const key in ApiScreeningDirection) {
        if (Object.prototype.hasOwnProperty.call(ApiScreeningDirection, key)) {
            if (ApiScreeningDirection[key as keyof typeof ApiScreeningDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiScreeningDirectionFromJSON(json: any): ApiScreeningDirection {
    return ApiScreeningDirectionFromJSONTyped(json, false);
}

export function ApiScreeningDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningDirection {
    return json as ApiScreeningDirection;
}

export function ApiScreeningDirectionToJSON(value?: ApiScreeningDirection | null): any {
    return value as any;
}

export function ApiScreeningDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiScreeningDirection {
    return value as ApiScreeningDirection;
}

